"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ViewMenuItem;

var _Popper2 = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Paper2 = _interopRequireDefault(require("@material-ui/core/Paper"));

var _ClickAwayListener2 = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _MenuList2 = _interopRequireDefault(require("@material-ui/core/MenuList"));

var _Delete2 = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _FileCopy2 = _interopRequireDefault(require("@material-ui/icons/FileCopy"));

var _MenuItem2 = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Edit2 = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

ViewMenuItem.propTypes = {
  id: _propTypes["default"].string,
  total: _propTypes["default"].number,
  color: _propTypes["default"].string,
  isSelectedView: _propTypes["default"].bool,
  onDelete: _propTypes["default"].func,
  onDuplicate: _propTypes["default"].func,
  setShowInputView: _propTypes["default"].func
};

function ViewMenuItem(_ref) {
  var id = _ref.id,
      setShowInputView = _ref.setShowInputView,
      isSelectedView = _ref.isSelectedView,
      color = _ref.color,
      total = _ref.total,
      onDelete = _ref.onDelete,
      onDuplicate = _ref.onDuplicate;

  var anchorRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showMore = _React$useState2[0],
      setShowMore = _React$useState2[1];

  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setShowMore(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setShowMore(false);
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      height: 39
    },
    ref: anchorRef,
    onClick: function onClick() {
      setShowMore(function (prevOpen) {
        return !prevOpen;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14",
    height: "4",
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 2C0.25 1.172 0.922 0.5 1.75 0.5C2.578 0.5 3.25 1.172 3.25 2C3.25 2.828 2.578 3.5 1.75 3.5C0.922 3.5 0.25 2.828 0.25 2ZM7.00001 0.5C6.17201 0.5 5.50001 1.172 5.50001 2C5.50001 2.828 6.17201 3.5 7.00001 3.5C7.82801 3.5 8.50001 2.828 8.50001 2C8.50001 1.172 7.82801 0.5 7.00001 0.5ZM12.25 0.5C11.422 0.5 10.75 1.172 10.75 2C10.75 2.828 11.422 3.5 12.25 3.5C13.078 3.5 13.75 2.828 13.75 2C13.75 1.172 13.078 0.5 12.25 0.5Z",
    fill: isSelectedView ? color : "#031330"
  }))), /*#__PURE__*/_react["default"].createElement(_Popper2["default"], {
    open: showMore,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true,
    style: {
      zIndex: 10000,
      marginTop: 8
    },
    modifiers: {
      offset: {
        enabled: true,
        offset: "0, 5"
      }
    },
    placement: "bottom-start"
  }, /*#__PURE__*/_react["default"].createElement(_Paper2["default"], {
    style: {
      boxShadow: "0 4px 17px 6px rgb(0 0 0 / 10%)"
    }
  }, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener2["default"], {
    onClickAway: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_MenuList2["default"], {
    style: {
      width: 150
    },
    autoFocusItem: showMore,
    id: "menu-list-grow",
    onKeyDown: handleListKeyDown
  }, /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
    onClick: function onClick() {
      setShowMore(false);
      setShowInputView(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Edit2["default"], {
    style: {
      marginRight: "0.5rem",
      fontSize: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: "0.875rem"
    }
  }, "Rename")), /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
    onClick: function onClick() {
      onDuplicate(id);
      setShowMore(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_FileCopy2["default"], {
    style: {
      marginRight: "0.5rem",
      fontSize: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: "0.875rem"
    }
  }, "Duplicate")), /*#__PURE__*/_react["default"].createElement(_MenuItem2["default"], {
    onClick: function onClick() {
      if (total <= 1) {
        return null;
      }

      onDelete(id);
      setShowMore(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Delete2["default"], {
    style: {
      marginRight: "0.5rem",
      fontSize: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: "0.875rem",
      color: total > 1 ? "unset" : "rgba(156, 163, 175,1)"
    }
  }, "Delete")))))));
}